import { gsap } from "gsap";
class PageHeader {
    // 2. events
    // 3. methods (function, action...)
    animate(){
        let tlPageHeader = gsap.timeline();
        let pageHeaderTitle= document.querySelector('.page-header__title');
        if(pageHeaderTitle){
            tlPageHeader.fromTo(pageHeaderTitle, { opacity: 0, yPercent:100 }, { opacity: 1, yPercent:0, duration: 0.4 },"+=1.3")
        }
    }
}
export default PageHeader